define(
  'app/views/ticket_buy_form_view',['app/setup', 'app/lib/pwt/persian-date','app/lib/pwt/persian-datepicker'],
  function(takhfifan, persianDate, pdp) {
    takhfifan.TicketBuyForm = Backbone.View.extend({
      events: {
        'click input[name="ticket_direction"]': 'toggle2way',
        'click .tkh-ticket-buy-form__direction li': 'changeDirection'
      },

      initialize: function () {
        window.persianDate = persianDate;
        this.direction = 1;
        this.$el.removeClass('loading-view');
        this.createAssociatedList();

        var $activeDirection = this.$('.tkh-ticket-buy-form__direction li.active');
        this.departureParentProductId = $activeDirection.data('from');
        this.returnParentProductId = $activeDirection.data('to');
        takhfifan.eventHub.trigger('tickets:formReset', {direction: this.direction, full: true});
        this.generateDatePickers();
      },

      generateDatePickers: function(){
        var _this = this,
            dpOptions = {
              onSelect: function(unix){
                var selectedDate=this.model.state.selected,
                  $placeHolder = $(this.model.inputElement),
                  selectedDateText = _this.formatDate(unix);
                $placeHolder.html(selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date);
                $placeHolder.addClass('ticket-buy-form__dpp--has-value');

                if($placeHolder.data("type")==="from"){
                  _this.departureDate = selectedDateText;
                  _this.departureProductId = _this.associated[_this.departureParentProductId][selectedDateText];
                  takhfifan.eventHub.trigger('tickets:departureDateSelected', _this.departureProductId);

                  _this.fromDP.touched = true;
                  if (_this.toDP && _this.toDP.options && _this.toDP.options.minDate != unix) {
                    var cachedValue = _this.toDP.getState().selected.unixDate;
                    _this.toDP.options = {minDate: unix};
                    if (_this.toDP.touched) {
                      _this.toDP.setDate(cachedValue);
                    }
                  }

                }else{
                  _this.returnDate = selectedDateText;
                  _this.returnProductId = _this.associated[_this.returnParentProductId][selectedDateText];
                  takhfifan.eventHub.trigger('tickets:returnDateSelected', _this.returnProductId);

                  _this.toDP.touched = true;
                  if(_this.fromDP && _this.fromDP.options && _this.fromDP.options.maxDate != unix){
                    var cachedValue = _this.fromDP.getState().selected.unixDate;
                    _this.fromDP.options = {maxDate: unix};
                    if (_this.fromDP.touched) {
                      _this.fromDP.setDate(cachedValue);
                    }
                  }
                }
              },
              checkDate: function(unix){
                var $placeHolder = $(this.model.inputElement),
                  currentDate = _this.formatDate(unix),
                  currentTable = $placeHolder.data("type")==="from"?_this.departureParentProductId:_this.returnParentProductId;
                return !!currentTable && _this.associated[currentTable] && _this.associated[currentTable][currentDate];
              },
              minDate: null,
              maxDate: null,
              autoClose: true,
              toolbox:{
                calendarSwitch:{
                  enabled: false
                }
              }
            };
        $(".ticket-buy-form__dpp").each(function(){
          $(this).removeClass('ticket-buy-form__dpp--has-value');
          $(this).html($(this).data("ph"));
        });
        if(this.fromDP){
          this.fromDP.options = dpOptions;
        }
        if(this.toDP){
          this.toDP.options = dpOptions;
        }
        if(!this.toDP || !this.fromDP){
          $(".ticket-buy-form__dpp").each(function(){
            var dp = $(this).pDatepicker(dpOptions);
            if($(this).data("type")==="from"){
              _this.fromDP = dp;
            }else{
              _this.toDP = dp;
            }
          });
        }
      },

      createAssociatedList: function(){
        this.associated = {};
        var _this = this,
            associatedList = JSON.parse(this.$('.tkh-associated-products-data').val()),
            isSoldOut = true;

        _.each(associatedList, function(subList, parentKey){
          _this.associated[parentKey] = {};
          _.each(subList, function(item, key){
            var itemModel =_this.collection.get(item);
            if((itemModel && !itemModel.attributes.expired && !itemModel.attributes.isSoldOut && itemModel.attributes.seconds>=0)){
              _this.associated[parentKey][String(key)] = item;
              isSoldOut = false;
            }
          });
        });

        if(isSoldOut){
          takhfifan.eventHub.trigger('tickets:soldOut');
        }
      },

      addLeadingZero: function (n) {
        var s = "0"+n;
        return s.substr(s.length-2);
      },

      formatDate: function(unix){
        var currentDate = new Date(unix);
        return (currentDate.getFullYear()+"-"+this.addLeadingZero(currentDate.getMonth() +1) +"-"+this.addLeadingZero(currentDate.getDate()));
      },

      render: function(){
        if(this.direction==2){
          this.$el.addClass('ticket-buy-form--two-way');
        }else{
          this.$el.removeClass('ticket-buy-form--two-way');
        }
      },

      changeDirection: function(e){
        var $target=$(e.target);
        this.departureParentProductId = $target.data('from');
        this.returnParentProductId = $target.data('to');
        this.generateDatePickers();
        takhfifan.eventHub.trigger('tickets:formReset', {direction: this.direction, full: true});
      },

      toggle2way: function(e){
        var $target=$(e.target);
        this.direction = $target.val();
        this.generateDatePickers();
        takhfifan.eventHub.trigger('tickets:formReset', {direction: this.direction, full: true});
        this.render();
      }

    })
});

